/* ============================================================
   FANY Drag-to-Scroll  ·  assets/fany-drag-scroll.js
   Ziehen der horizontalen Slider mit der Maus (Desktop).
   - Nur Maus/Feinzeiger; Touch bleibt nativ (Handy unveraendert)
   - Klick-sicher: kurze Klicks auf Karten/Links funktionieren normal,
     nur echtes Ziehen scrollt (Schwelle in Pixeln)
   - Scroll-Snap wird waehrend des Ziehens kurz deaktiviert
   - Zentral: greift ueber die vorhandenen Slider-Container,
     die Slider-Sections selbst muessen NICHT angepasst werden
   - Global schaltbar ueber window.FANY_SLIDER_DRAG (Theme-Einstellung)
   ============================================================ */
(function () {
  'use strict';

  if (window.__fanyDragInit) return;
  window.__fanyDragInit = true;

  // Globaler Schalter (Theme-Einstellung). Standard: aktiv.
  if (window.FANY_SLIDER_DRAG === false) return;

  // Scroll-Container aller FANY-Slider (bereits im Theme vorhanden)
  var SELECTOR = '[data-fas-slider],[data-fcts-slider],[data-fms-slider],.fany-product-sllid-row__slider';
  var THRESHOLD = 6; // px: ab hier gilt es als Ziehen statt Klick

  function enable(el) {
    if (el.__fanyDrag) return;
    el.__fanyDrag = true;
    el.classList.add('fany-drag-ready');

    var down = false, moved = false, startX = 0, startScroll = 0, snapPrev = '';

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return; // nur linke Maustaste
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      snapPrev = el.style.scrollSnapType;
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < THRESHOLD) return;
      if (!moved) {
        moved = true;
        el.classList.add('fany-dragging');
        el.style.scrollSnapType = 'none';
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      }
      el.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function end() {
      if (!down) return;
      down = false;
      if (moved) {
        el.classList.remove('fany-dragging');
        el.style.scrollSnapType = snapPrev;
        // den unmittelbar folgenden Klick unterdruecken (Karten-Link nicht ausloesen)
        var suppress = function (ev) {
          ev.stopPropagation();
          ev.preventDefault();
          el.removeEventListener('click', suppress, true);
        };
        el.addEventListener('click', suppress, true);
        setTimeout(function () { el.removeEventListener('click', suppress, true); }, 0);
      }
      moved = false;
    }

    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    // kein Ghost-Dragging von Bildern/Links waehrend des Ziehens
    el.addEventListener('dragstart', function (e) { if (moved) e.preventDefault(); });
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      // pro Slider abschaltbar: data-fany-drag="false"
      if (el.getAttribute('data-fany-drag') === 'false') return;
      enable(el);
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });

  // Theme-Editor: neu geladene/geaenderte Sections nachruesten
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
